import { render, staticRenderFns } from "./DashboardFilterGroup.vue?vue&type=template&id=56d4cec5&scoped=true&"
import script from "./DashboardFilterGroup.ts?vue&type=script&lang=ts&"
export * from "./DashboardFilterGroup.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardFilterGroup.scss?vue&type=style&index=0&id=56d4cec5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4cec5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
